


export default class TTLCounter {

    // interval: number = 60;
    rate: number = 1000;
    timer: any;

    constructor(
        private interval: number = 60,
        private callback: (ttl: number) => void
    ) {

    }


    start(): void {
        this._start();
    }

    reset() {
        this._start();
    }

    _start(): void {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }

        let last = Date.now();
        let run = (ttl: number) => {
            this.callback(ttl);
            ttl--;
            if (ttl < 0) {
                this.close();
                return;
            }
            let now = Date.now();
            let delta = Math.max(0, this.rate - (now-last));
            last = now + delta;
            this.timer = setTimeout(run, delta, ttl)
        };
        run(this.interval);
    }

    close() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

}